import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bo/earnings/')({
  component: () => <Navigate replace search to="/bo/settings" />,
})
